import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=457efac5&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=457efac5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457efac5",
  null
  
)

export default component.exports